import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  margin: auto;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  max-width: 600px;

  > div {
    flex-shrink: 0;
    flex-grow: 0;
  }
`;

export const NavigationHeaderWrapper = styled.div`
  width: 100%;
  height: 50px;
  margin-bottom: 8px;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Main = styled.main`
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const Label = styled.span<{ bold?: boolean; refundAmount?: boolean }>`
  font-size: 14px;
  line-height: 20px;
  color: var(--way-colors-contrastColorShades-60);
`;

export const RescheduleMessage = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  border: 0.5px solid var(--way-colors-borderColor);
  margin-top: 32px;
  margin-bottom: 32px;
  align-items: center;
`;
